var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reg-step" },
    [
      _vm.showIntro
        ? _c(
            "div",
            { staticClass: "step-hint-bar" },
            [
              _vm._m(0),
              _c(
                "a-button",
                {
                  staticClass: "pro-hint-btn",
                  attrs: { shape: "round", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("toggle-intro", !_vm.showIntro)
                    },
                  },
                },
                [_vm._v(" I'm a pro, minimize hints ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "a-form-model",
        {
          ref: "form",
          staticClass: "reg-form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-col": { span: 24 },
            "wrapper-col": { span: 24 },
          },
        },
        [
          _c(
            "div",
            { staticClass: "form-block" },
            [
              _c("div", { staticClass: "block-title" }, [
                _c("span", { staticClass: "title-icon" }, [_vm._v("✅")]),
                _c("span", [_vm._v("Campaign Name")]),
              ]),
              _c(
                "a-form-model-item",
                { attrs: { prop: "campaignName" } },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: "Please enter the campaign name",
                      size: "large",
                    },
                    model: {
                      value: _vm.form.campaignName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "campaignName", $$v)
                      },
                      expression: "form.campaignName",
                    },
                  }),
                ],
                1
              ),
              _vm.showIntro
                ? _c("div", { staticClass: "block-tip" }, [
                    _c("span", { staticClass: "tip-icon" }, [_vm._v("💡")]),
                    _c("span", {
                      staticClass: "tip-content",
                      domProps: { innerHTML: _vm._s(_vm.campaignNameTip) },
                    }),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-block" },
            [
              _c(
                "div",
                { staticClass: "block-title" },
                [
                  _c("span", { staticClass: "title-icon linkedin-icon" }, [
                    _vm._v("💼"),
                  ]),
                  _c("span", [_vm._v("Connect Your LinkedIn Account")]),
                  _c("a-icon", {
                    staticClass: "title-help-icon",
                    attrs: { type: "question-circle" },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "safe-card" }, [
                _c(
                  "div",
                  {
                    staticClass: "safe-card-header",
                    on: {
                      click: function ($event) {
                        _vm.safeCardExpanded = !_vm.safeCardExpanded
                      },
                    },
                  },
                  [
                    _c("span", [
                      _c("span", { staticClass: "shield-icon" }, [
                        _vm._v("🛡️"),
                      ]),
                      _vm._v(" Why connect? Is it safe?"),
                    ]),
                    _c("a-icon", {
                      attrs: { type: _vm.safeCardExpanded ? "up" : "down" },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.safeCardExpanded,
                        expression: "safeCardExpanded",
                      },
                    ],
                    staticClass: "safe-card-body",
                  },
                  [
                    _c("div", {
                      staticClass: "safe-intro",
                      domProps: { innerHTML: _vm._s(_vm.whyConnectIntro) },
                    }),
                    _c("div", { staticClass: "safe-grid" }, [
                      _c("div", { staticClass: "safe-item" }, [
                        _c("span", { staticClass: "safe-item-icon" }, [
                          _vm._v("🌐"),
                        ]),
                        _c("div", { staticClass: "safe-item-text" }, [
                          _c("div", { staticClass: "safe-item-title" }, [
                            _vm._v("Dedicated proxy IP"),
                          ]),
                          _c("div", { staticClass: "safe-item-desc" }, [
                            _vm._v(
                              " Matches your usual login location to mimic a local login "
                            ),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "safe-item" }, [
                        _c("span", { staticClass: "safe-item-icon" }, [
                          _vm._v("🐢"),
                        ]),
                        _c("div", { staticClass: "safe-item-text" }, [
                          _c("div", { staticClass: "safe-item-title" }, [
                            _vm._v("Human-like rate limits"),
                          ]),
                          _c("div", { staticClass: "safe-item-desc" }, [
                            _vm._v(
                              " Sends at a natural human pace to stay within limits "
                            ),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "safe-item" }, [
                        _c("span", { staticClass: "safe-item-icon" }, [
                          _vm._v("🔒"),
                        ]),
                        _c("div", { staticClass: "safe-item-text" }, [
                          _c("div", { staticClass: "safe-item-title" }, [
                            _vm._v("Encrypted storage"),
                          ]),
                          _c("div", { staticClass: "safe-item-desc" }, [
                            _vm._v(
                              " Credentials are encrypted; nothing unrelated is ever done "
                            ),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "safe-item" }, [
                        _c("span", { staticClass: "safe-item-icon" }, [
                          _vm._v("🔓"),
                        ]),
                        _c("div", { staticClass: "safe-item-text" }, [
                          _c("div", { staticClass: "safe-item-title" }, [
                            _vm._v("Disconnect anytime"),
                          ]),
                          _c("div", { staticClass: "safe-item-desc" }, [
                            _vm._v("Revoke access with one click"),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c(
                      "a",
                      {
                        staticClass: "learn-more",
                        attrs: { href: "javascript:void(0)" },
                      },
                      [_vm._v("Learn how we protect your account →")]
                    ),
                  ]
                ),
              ]),
              _c(
                "a-input",
                {
                  staticClass: "linkedin-input",
                  attrs: {
                    placeholder: "LinkedIn email",
                    size: "large",
                    readonly: "",
                  },
                  model: {
                    value: _vm.form.linkedinEmail,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "linkedinEmail", $$v)
                    },
                    expression: "form.linkedinEmail",
                  },
                },
                [
                  _c("a-icon", {
                    attrs: { slot: "prefix", type: "link" },
                    slot: "prefix",
                  }),
                  _c("a-icon", {
                    attrs: {
                      slot: "suffix",
                      type: "check-circle",
                      theme: "twoTone",
                      "two-tone-color": "#52c41a",
                    },
                    slot: "suffix",
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "form-block" }, [
            _c(
              "div",
              { staticClass: "block-title" },
              [
                _c("span", { staticClass: "title-icon chart-icon" }, [
                  _vm._v("📊"),
                ]),
                _c("span", [_vm._v("Daily Connection Request Limit")]),
                _c("a-icon", {
                  staticClass: "title-help-icon",
                  attrs: { type: "question-circle" },
                }),
              ],
              1
            ),
            _vm.showIntro
              ? _c("div", { staticClass: "block-tip" }, [
                  _c("span", { staticClass: "tip-icon" }, [_vm._v("🌟")]),
                  _c("span", {
                    staticClass: "tip-content",
                    domProps: { innerHTML: _vm._s(_vm.dailyLimitTip) },
                  }),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "limit-row" },
              [
                _c(
                  "a-button",
                  {
                    staticClass: "limit-btn",
                    attrs: {
                      shape: "circle",
                      disabled: _vm.form.dailyLimit <= 1,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onLimitChange(-1)
                      },
                    },
                  },
                  [_c("a-icon", { attrs: { type: "minus" } })],
                  1
                ),
                _c("a-input-number", {
                  staticClass: "limit-input",
                  attrs: { min: 1, max: 100, controls: false },
                  model: {
                    value: _vm.form.dailyLimit,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "dailyLimit", $$v)
                    },
                    expression: "form.dailyLimit",
                  },
                }),
                _c(
                  "a-button",
                  {
                    staticClass: "limit-btn",
                    attrs: {
                      shape: "circle",
                      disabled: _vm.form.dailyLimit >= 100,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onLimitChange(1)
                      },
                    },
                  },
                  [_c("a-icon", { attrs: { type: "plus" } })],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "form-block" },
            [
              _c("div", { staticClass: "block-title" }, [
                _c("span", { staticClass: "title-icon target-icon" }, [
                  _vm._v("🎯"),
                ]),
                _c("span", [_vm._v("Select Allocation Mode")]),
              ]),
              _vm.showIntro
                ? _c("div", { staticClass: "block-tip" }, [
                    _c("span", { staticClass: "tip-icon" }, [_vm._v("🌟")]),
                    _c("span", {
                      staticClass: "tip-content",
                      domProps: { innerHTML: _vm._s(_vm.allocationModeTip) },
                    }),
                  ])
                : _vm._e(),
              _c("allocation-options", {
                attrs: {
                  allocationMode: _vm.form.allocationMode,
                  dailyLimit: _vm.form.dailyLimit,
                  activeCampaignsCount: _vm.activeCampaignsCount,
                },
                on: { change: _vm.handleAllocationChange },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "form-actions" },
        [
          _vm._t("actions", null, {
            submit: _vm.onSave,
            cancel: _vm.onCancel,
            saving: _vm.saving,
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "step-hint-left" }, [
      _c("span", { staticClass: "hand-icon" }, [_vm._v("👋")]),
      _c("div", { staticClass: "step-hint-text" }, [
        _c("div", { staticClass: "step-hint-title" }, [
          _vm._v(" Step 1 of 5: name it + connect LinkedIn. "),
        ]),
        _c("div", { staticClass: "step-hint-desc" }, [
          _vm._v(
            " Just follow along — about 2 minutes to let AI start working for you! "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }